export const USER_ASSIGNEDTASKS_REQUEST = 'USER_ASSIGNEDTASKS_REQUEST'
export const USER_ASSIGNEDTASKS_SUCCESS = 'USER_ASSIGNEDTASKS_SUCCESS'
export const USER_ASSIGNEDTASKS_FAIL = 'USER_ASSIGNEDTASKS_FAIL'

export const USER_ASSIGNEDTASK_REQUEST = "USER_ASSIGNEDTASK_REQUEST";
export const USER_ASSIGNEDTASK_SUCCESS = "USER_ASSIGNEDTASK_SUCCESS";
export const USER_ASSIGNEDTASK_FAIL = "USER_ASSIGNEDTASK_FAIL";
